import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { IParkingHistoryHub } from '../models/parking-map';

@Injectable({
  providedIn: 'root',
})
export class ParkingHistoriesHubService {
  private hubConnection!: signalR.HubConnection;
  public parkingUpdates$ = new Subject<IParkingHistoryHub>();

  public initConnection(): void {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl('https://opp-api.jquo.kz/parking-histories', {
        withCredentials: true,
      })
      .build();

    this.hubConnection
      .start()
      .then(() => {
        this.subscribeToAllUpdates().then();
      })
      .catch(err => console.error('Error while connecting SignalR:', err));

    this.hubConnection.on('ReceiveFullEvent', (message: IParkingHistoryHub) => {
      this.parkingUpdates$.next(message);
    });
  }

  private async subscribeToAllUpdates(): Promise<void> {
    try {
      await this.hubConnection.invoke('SubscribeToAllUpdates');
      console.log('Subscribed to all parkings updates');
    } catch (err) {
      console.error('Error while subscribing to updates:', err);
    }
  }
}
